import Immutable from 'immutable';
import React from 'react';

import LinkButton from 'sharedreact/components/LinkButton';
import Tab from 'sharedreact/components/Tab';
import Toolbar from 'sharedreact/components/Toolbar';
import ToolbarGroup from 'sharedreact/components/ToolbarGroup';
import ToolbarTitle from 'sharedreact/components/ToolbarTitle';
import SortOrder from 'sharedreact/data/SortOrder';
import { RangeType } from 'sharedreact/stores/generic/Type';
import { translate } from 'sharedreact/utils/LanguageSupport';

import TokensTable from 'workspaces/launcher/components/admin/TokensTable';
import Token from 'workspaces/launcher/data/Token';

type Props = {
  index: number,
  activeTab: number,
  language: string,
  tokens: Immutable.List<Token | null>,
  selection: Immutable.Set<string>,
  sortOrder: SortOrder,

  onLoad: () => void,
  onRevokeToken: (token: Token) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,
  onItemSelect?: (id: string) => void,
  setVisibleRange: (visibleRange: RangeType) => void
};

class TokensTab extends React.Component<Props> {
  override componentDidMount (): void {
    if (this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    if (prevProps.activeTab !== this.props.activeTab && this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override render (): React.ReactNode {
    const {
      index, activeTab,
      tokens,
      selection, sortOrder,
      language, // eslint-disable-line no-unused-vars
      onRevokeToken,
      onSortOrderChange, onItemSelect, setVisibleRange
    } = this.props;

    return (
      <Tab index={index} activeIndex={activeTab}>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarGroup>
              <ToolbarTitle title={translate('launcher.admin.tokens.title')} />
            </ToolbarGroup>
            <ToolbarGroup align='right'>
              <LinkButton
                id='ae_button_token_new'
                collapsable
                icon='bi bi-plus-lg'
                to='/admin?tab=managetokens&action=create'
              >
                {translate('launcher.admin.tokens.newbutton')}
              </LinkButton>
            </ToolbarGroup>
          </ToolbarGroup>
        </Toolbar>
        <div className='webappslauncher-scroll-container'>
          <div className='webappslauncher-stretch-container'>
            <TokensTable
              language={language}
              tokens={tokens}
              selection={selection}
              showSelection
              sortOrder={sortOrder}
              emptyTableText='launcher.admin.tokenslist.notokens'
              onRevokeToken={onRevokeToken}
              onSortOrderChange={onSortOrderChange}
              onItemSelect={onItemSelect}
              setVisibleRange={setVisibleRange}
            />
          </div>
        </div>
      </Tab>
    );
  }
}

export default TokensTab;
